import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Store} from "@ngrx/store";
import * as fromStore from "../store";
import {filter, first, switchMap} from 'rxjs/operators';
import {UserSubscription, UserSubscriptionType} from "../user/user-subscription";
import {UserService} from "../user/user.service";
import {Website} from "../websites/website/website";
import {Subject} from "rxjs";

@Component({
    selector: 'db-website-title',
    templateUrl: './website-title.component.html',
    styleUrls: ['./website-title.component.scss'],
    standalone: false
})
export class WebsiteTitleComponent implements OnInit, OnDestroy {

  public userSubscription: UserSubscription;
  public UserSubscriptionType = UserSubscriptionType;
  public paymentMethods: any;
  public stoppedWebsites: Website[];
  @Input() website: Website;
  @Input() sidebarIsToggled: boolean;

  private _destroyStream$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private _store: Store<fromStore.DbStoreState>,
    private _userService: UserService,
  ) {
  }

  ngOnInit() {
    this.addSubscriptions();
  }

  ngOnDestroy() {
    this._destroyStream$.next(true);
    this._destroyStream$.complete();
  }

  private addSubscriptions(): void {
    this._store.select(fromStore.getUserLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getUserSubscription)),
        first()
      )
      .subscribe((data: any) => {
        this.userSubscription = data;
      });
    this._store.select(fromStore.getWebsitesLoaded)
      .pipe(
        filter((loaded: boolean) => loaded),
        switchMap(() => this._store.select(fromStore.getStoppedWebsites)),
        first()
      )
      .subscribe((data: any) => {
        this.stoppedWebsites = data;
      });
  }
}
